import { MenuItem } from "./MenuItem";
import { Link } from "react-router-dom";
import { useState } from "react";
import './NavbarStyle.css';
const Navbar = () => {
    const [bar, setBar] = useState(false);
    return (
        <nav className="nav-container">
            <h1 className="nav-logo">Rishav</h1>

            <div className="menu-icon" onClick={() => setBar(!bar)}>
                <i className={bar ? "fa-solid fa-times" : "fa-solid fa-bars"}></i>
            </div>
            
            <ul className={bar ? "nav-menu active" : "nav-menu"}>
                {
                    MenuItem.map((item, index) => {
                        return (
                            <li key={index}>
                                <Link className={item.cName} to={item.url}><i class={item.icon}></i>{item.title}</Link>
                            </li>
                        )
                    })
                }
            </ul>
        </nav>
    )
}
export default Navbar;